import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import localforage from 'localforage'
import React, { FC, useState } from 'react'

import { createQueryClient } from '@/integrations/react-query'

type Props = {
  children: React.ReactNode
}

export const QueryProvider: FC<Props> = ({ children }) => {
  const [queryClient] = useState(() => createQueryClient())
  const [asyncPersister] = useState(() =>
    createAsyncStoragePersister({
      storage: localforage,
    }),
  )

  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister: asyncPersister }}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </PersistQueryClientProvider>
  )
}
